export class StatusData {
  Data: Status[];
  Count: number;
}

export class Status {
  Id?: number;
  SUid?: string;
  Name1?: string;
  Name2?: string;
  IsNeutral?: boolean;
  ViewPoint?: number;
  CategoryCO?: number;
  CategoryCT?: number;
  CategorySC?: number;
  IsChecked?: boolean = false;
}